import useTypedContext from "hooks/useTypedContext";
import useCanRetryRun from "shared/Run/access/useCanRetryRun";
import getRunActions from "shared/Run/getRunActions";
import useCanPerformTaskAgain from "shared/Stack/access/useCanPerformTaskAgain";
import useCanTriggerStack from "shared/Stack/access/useCanTriggerStack";
import { RunContext } from "components/Run/Context";

const useRunActions = () => {
  const { run, stack } = useTypedContext(RunContext);
  const isStack = stack.__typename === "Stack";

  const canRetry = useCanRetryRun()(run, stack);
  const canTriggerStack = useCanTriggerStack();
  const canPerformTaskAgain = useCanPerformTaskAgain();

  return getRunActions({
    runType: run.type,
    runState: run.state,
    isRunFinished: run.finished,
    isStackDeleting: isStack && stack.deleting,
    runCommitHash: run.commit?.hash,
    stackTrackedCommitHash: isStack ? stack.trackedCommit?.hash : undefined,
    runRetryBlocker: run.retryBlocker,
    canRetry,
    canTrigger: isStack ? canTriggerStack(stack) : undefined,
    canPerformAgain: isStack ? canPerformTaskAgain(run, stack) : undefined,
  });
};

export default useRunActions;
